import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'

export class GetAuthSellerPDFApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'AuthSeller/generate-pdf',
      requesterInfo,
    })
  }

  public async GetAuthSellerPDFApi(req: any): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
